import { ChangeDetectionStrategy, Component, OnDestroy } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { SampleDataLoadingService } from '../../services/sample-data-loading.service';

/**
 * Global spinner dialog that displays whenever pull_sample_data is running.
 */
export const SAMPLE_DATA_LOADING_DIALOG_ID = 'sample-data-loading-dialog';

@Component({
  selector: 'app-sample-data-loading-dialog',
  templateUrl: './sample-data-loading-dialog.component.html',
  styleUrl: './sample-data-loading-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SampleDataLoadingDialogComponent implements OnDestroy {
  isAnimatingOut = false;
  private dismissTimeoutId: ReturnType<typeof setTimeout> | null = null;

  constructor(
    private dialogRef: MatDialogRef<SampleDataLoadingDialogComponent>,
    private sampleDataLoadingService: SampleDataLoadingService
  ) { }

  dismiss(): void {
    if (this.isAnimatingOut) {
      return;
    }
    this.isAnimatingOut = true;
    this.sampleDataLoadingService.markDismissed();
    this.dismissTimeoutId = setTimeout(() => this.dialogRef.close('dismissed'), 350);
  }

  ngOnDestroy(): void {
    if (this.dismissTimeoutId !== null) {
      clearTimeout(this.dismissTimeoutId);
      this.dismissTimeoutId = null;
    }
  }
}
